import React from 'react'
import { withTranslation } from 'react-i18next'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'

import StaffIndexContainer from './StaffIndexContainer'

class StaffIndexPage extends React.Component {
    componentDidMount() {
        document.title = 'Staffs | OSH CRM'
    }

    render() {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                    {path: '/staffs', name: 'Staffs'}
                ]}>
                    <ContentLayout>
                        <StaffIndexContainer/>
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default withTranslation('common')(StaffIndexPage)
